import * as yup from 'yup'

export const point = yup.object().shape({
  companiaId: yup.string().required('La compañía es obligatorio'),
  clienteId: yup.string().required('El cliente es obligatorio'),
  siteId: yup.string().required('El site es obligatorio'),
  campamentoId: yup.string().required('El campamento es obligatorio'),
  nombre: yup.string().required('El nombre es obligatorio'),
  capacidadInstalada: yup.string().required('La capacidad es obligatorio'),
  cantidadMaquinas: yup.string().required('La cantidad es obligatorio'),
  tipoAdministracion: yup.string().required('El tipo de administración es obligatorio'),
  proveedorId: yup.string().when('tipoAdministracion', {
    is: (tipoAdministracion) => tipoAdministracion === 'EXTERNO',
    then: yup.string().required('El proveedor es obligatorio'),
    otherwise: yup.string(),
  }),
  principal: yup.boolean(),
})
